import React from 'react'

import {
  HOMEPAGE_FIELDS,
  LOCAL_BUSINESS_FIELDS,
  SLIDE_FIELDS,
} from '../../constants/fieldGroups.constant'
import AbstractDocument from '../Abstract/AbstractDocument'

const Testimonial = function () {
  return (
    <AbstractDocument
      singleCollectionName="Testimonial"
      notToShow={[
        'ancestorIds',
        'parentId',
        'images',
        'videos',
        'type',
        ...SLIDE_FIELDS,
        ...HOMEPAGE_FIELDS,
        ...LOCAL_BUSINESS_FIELDS,
      ]}
    />
  )
}
export default Testimonial
